import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconsInitConfigType } from '../../../constants/icon.constants';
import { LabelLocationColorType, LabelLocationSizeType } from '../../../types';
import { LABEL_LOCATION_COLORS_MAP, LABEL_LOCATION_SIZES_MAP } from '../../../constants';
import { IconUIComponent } from '../icon/icon.component';

@Component({
  selector: 'fr8bot-ui-label-location',
  imports: [IconUIComponent],
  templateUrl: './label-location.component.html',
  styleUrl: './label-location.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabelLocationUIComponent {
  readonly iconName = input<IconsInitConfigType | undefined>(undefined);
  readonly size = input<LabelLocationSizeType>('large');
  readonly color = input<LabelLocationColorType>('orange');

  readonly COLORS_MAP = LABEL_LOCATION_COLORS_MAP;
  readonly SIZES_MAP = LABEL_LOCATION_SIZES_MAP;
}
